import signInApi from './modules/signIn';
export default {
  //签到模块api
  ...signInApi,
};
